module.exports = __webpack_public_path__ + "static/media/startpage2026_480.d612e7ff.jpg";